export default {
  locale: "fr",
  name: "Configurations d'annulation",
  translation: { displayName: "Traductions" },
  fields: {
    list: [
      {
        fieldName: "cancelOnline",
        displayName: "Peut annuler en ligne",
      },
      {
        fieldName: "type",
        displayName: "Type de pénalité",
        widget: "arrayPropertyRenderer",
        searchCriteria: "type",
        fieldSelector: {
          FIX_AMOUNT: "Montant fixe",
          PERCENTAGE: "Pourcentage",
          CHARGE_FIRST_NIGHT: "Première nuit",
        },
      },
    ],
    form: [
      {
        fieldName: "cancelOnline",
        displayName: "Peut annuler en ligne",
        widget: "checkbox",
      },
      {
        fieldName: "maxRelease",
        displayName: "Début de la période d'annulation",
        widget: "cancellationRange",
        helpText:
          "Définit le jour et l'heure de début de cette pénalité (par rapport à la date d'arrivée)",
        defaultValue: "undefined",
        optionDisplayFirst: {
          undefined: { label: "Sans restriction" },
          "0": { label: "Le jour même de l'arrivée" },
          "1": { label: "1 jour avant l'arrivée" },
          "2": { label: "2 jours avant l'arrivée" },
          "3": { label: "3 jours avant l'arrivée" },
          "4": { label: "4 jours avant l'arrivée" },
          "5": { label: "5 jours avant l'arrivée" },
          "6": { label: "6 jours avant l'arrivée" },
          "7": { label: "7 jours avant l'arrivée" },
          "8": { label: "8 jours avant l'arrivée" },
          "9": { label: "9 jours avant l'arrivée" },
          "10": { label: "10 jours avant l'arrivée" },
          "11": { label: "11 jours avant l'arrivée" },
          "12": { label: "12 jours avant l'arrivée" },
          "13": { label: "13 jours avant l'arrivée" },
          "14": { label: "14 jours avant l'arrivée" },
          "15": { label: "15 jours avant l'arrivée" },
          "16": { label: "16 jours avant l'arrivée" },
          "17": { label: "17 jours avant l'arrivée" },
          "18": { label: "18 jours avant l'arrivée" },
          "19": { label: "19 jours avant l'arrivée" },
          "20": { label: "20 jours avant l'arrivée" },
          "21": { label: "21 jours avant l'arrivée" },
          "22": { label: "22 jours avant l'arrivée" },
          "23": { label: "23 jours avant l'arrivée" },
          "24": { label: "24 jours avant l'arrivée" },
          "25": { label: "25 jours avant l'arrivée" },
          "26": { label: "26 jours avant l'arrivée" },
          "27": { label: "27 jours avant l'arrivée" },
          "28": { label: "28 jours avant l'arrivée" },
          "29": { label: "29 jours avant l'arrivée" },
          "30": { label: "30 jours avant l'arrivée" },
          "35": { label: "35 jours avant l'arrivée" },
          "40": { label: "40 jours avant l'arrivée" },
          "45": { label: "45 jours avant l'arrivée" },
          "50": { label: "50 jours avant l'arrivée" },
          "55": { label: "55 jours avant l'arrivée" },
          "60": { label: "60 jours avant l'arrivée" },
          "90": { label: "90 jours avant l'arrivée" },
          "120": { label: "120 jours avant l'arrivée" },
          "150": { label: "150 jours avant l'arrivée" },
          "180": { label: "180 jours avant l'arrivée" },
          "210": { label: "210 jours avant l'arrivée" },
          "240": { label: "240 jours avant l'arrivée" },
          "270": { label: "270 jours avant l'arrivée" },
          "300": { label: "300 jours avant l'arrivée" },
          "330": { label: "330 jours avant l'arrivée" },
          "360": { label: "360 jours avant l'arrivée" },
        },
        optionDisplaySecond: {
          "00:01": { label: "0:01" },
          "01:00": { label: "1:00" },
          "02:00": { label: "2:00" },
          "03:00": { label: "3:00" },
          "04:00": { label: "4:00" },
          "05:00": { label: "5:00" },
          "06:00": { label: "6:00" },
          "07:00": { label: "7:00" },
          "08:00": { label: "8:00" },
          "09:00": { label: "9:00" },
          "10:00": { label: "10:00" },
          "11:00": { label: "11:00" },
          "12:00": { label: "12:00" },
          "13:00": { label: "13:00" },
          "14:00": { label: "14:00" },
          "15:00": { label: "15:00" },
          "16:00": { label: "16:00" },
          "17:00": { label: "17:00" },
          "18:00": { label: "18:00" },
          "19:00": { label: "19:00" },
          "20:00": { label: "20:00" },
          "21:00": { label: "21:00" },
          "22:00": { label: "22:00" },
          "23:00": { label: "23:00" },
          "23:59": { label: "23:59" },
        },
      },
      {
        fieldName: "minRelease",
        displayName: "Fin de la période d'annulation",
        widget: "cancellationRange",
        helpText:
          "Définit le jour et l'heure de fin de cette pénalité (par rapport à la date d'arrivée)",
        defaultValue: "undefined",
        optionDisplayFirst: {
          undefined: { label: "Sans restriction" },
          "0": { label: "Le jour même de l'arrivée" },
          "1": { label: "1 jour avant l'arrivée" },
          "2": { label: "2 jours avant l'arrivée" },
          "3": { label: "3 jours avant l'arrivée" },
          "4": { label: "4 jours avant l'arrivée" },
          "5": { label: "5 jours avant l'arrivée" },
          "6": { label: "6 jours avant l'arrivée" },
          "7": { label: "7 jours avant l'arrivée" },
          "8": { label: "8 jours avant l'arrivée" },
          "9": { label: "9 jours avant l'arrivée" },
          "10": { label: "10 jours avant l'arrivée" },
          "11": { label: "11 jours avant l'arrivée" },
          "12": { label: "12 jours avant l'arrivée" },
          "13": { label: "13 jours avant l'arrivée" },
          "14": { label: "14 jours avant l'arrivée" },
          "15": { label: "15 jours avant l'arrivée" },
          "16": { label: "16 jours avant l'arrivée" },
          "17": { label: "17 jours avant l'arrivée" },
          "18": { label: "18 jours avant l'arrivée" },
          "19": { label: "19 jours avant l'arrivée" },
          "20": { label: "20 jours avant l'arrivée" },
          "21": { label: "21 jours avant l'arrivée" },
          "22": { label: "22 jours avant l'arrivée" },
          "23": { label: "23 jours avant l'arrivée" },
          "24": { label: "24 jours avant l'arrivée" },
          "25": { label: "25 jours avant l'arrivée" },
          "26": { label: "26 jours avant l'arrivée" },
          "27": { label: "27 jours avant l'arrivée" },
          "28": { label: "28 jours avant l'arrivée" },
          "29": { label: "29 jours avant l'arrivée" },
          "30": { label: "30 jours avant l'arrivée" },
          "35": { label: "35 jours avant l'arrivée" },
          "40": { label: "40 jours avant l'arrivée" },
          "45": { label: "45 jours avant l'arrivée" },
          "50": { label: "50 jours avant l'arrivée" },
          "55": { label: "55 jours avant l'arrivée" },
          "60": { label: "60 jours avant l'arrivée" },
          "90": { label: "90 jours avant l'arrivée" },
          "120": { label: "120 jours avant l'arrivée" },
          "150": { label: "150 jours avant l'arrivée" },
          "180": { label: "180 jours avant l'arrivée" },
          "210": { label: "210 jours avant l'arrivée" },
          "240": { label: "240 jours avant l'arrivée" },
          "270": { label: "270 jours avant l'arrivée" },
          "300": { label: "300 jours avant l'arrivée" },
          "330": { label: "330 jours avant l'arrivée" },
          "360": { label: "360 jours avant l'arrivée" },
        },
        optionDisplaySecond: {
          "00:01": { label: "0:01" },
          "01:00": { label: "1:00" },
          "02:00": { label: "2:00" },
          "03:00": { label: "3:00" },
          "04:00": { label: "4:00" },
          "05:00": { label: "5:00" },
          "06:00": { label: "6:00" },
          "07:00": { label: "7:00" },
          "08:00": { label: "8:00" },
          "09:00": { label: "9:00" },
          "10:00": { label: "10:00" },
          "11:00": { label: "11:00" },
          "12:00": { label: "12:00" },
          "13:00": { label: "13:00" },
          "14:00": { label: "14:00" },
          "15:00": { label: "15:00" },
          "16:00": { label: "16:00" },
          "17:00": { label: "17:00" },
          "18:00": { label: "18:00" },
          "19:00": { label: "19:00" },
          "20:00": { label: "20:00" },
          "21:00": { label: "21:00" },
          "22:00": { label: "22:00" },
          "23:00": { label: "23:00" },
          "23:59": { label: "23:59" },
        },
      },
      {
        fieldName: "type",
        displayName: "Type de pénalité (jours)",
        widget: "selector",
        optionDisplay: {
          FIX_AMOUNT: {
            label: "Montant fixe",
          },
          PERCENTAGE: {
            label: "Pourcentage",
          },
          CHARGE_FIRST_NIGHT: {
            label: "Première nuit",
          },
        },
        defaultValue: "FIX_AMOUNT",
      },
      {
        fieldName: "penalty",
        displayName: "Montant",
        widget: "input",
      },
    ],
  },
};
